var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSpent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(-180 48 48)",
    fill: "#880808"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3189 30.01C18.3981 30.5566 18.9053 30.9355 19.4519 30.8563L28.359 29.5663C28.9056 29.4871 29.2845 28.9798 29.2053 28.4333C29.1262 27.8867 28.6189 27.5078 28.0723 27.5869L20.1549 28.7336L19.0082 20.8162C18.9291 20.2697 18.4218 19.8907 17.8752 19.9699C17.3286 20.0491 16.9497 20.5563 17.0289 21.1029L18.3189 30.01ZM29.9977 13.8859L18.5074 29.2682L20.1097 30.4651L31.6 15.0828L29.9977 13.8859Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSpent);
export default __webpack_public_path__ + "static/media/user-spent.fcb6556f2944c6e5fb8bfa883883d214.svg";
export { ForwardRef as ReactComponent };